@if (componentData$ | async; as carousel) {
  @if (banners$ | async; as banners) {
    <div
      class="aimo-banner-carousel"
            [ngClass]="{
                'aimo-banner-carousel-smaller': banners.length > 3,
            }">
      <div
        class="aimo-background"
                [ngClass]="{
                    'bg-white': carousel.backgroundColor === 'WHITE',
                    'bg-light-grey': carousel.backgroundColor === 'GREY',
                    'bg-petrol-light': carousel.backgroundColor === 'PETROL_LIGHT',
                }">
        <div class="container">
          <aimo-cx-carousel
            class="carousel-banners"
            role="region"
            tabindex="-1"
            itemWidth="10px"
            [hideIndicators]="true"
            [banners]="banners"
            [title]="carousel.headText"
            [template]="carouselItem"
            [gtmParams]="gtmParams"
            [idSuffix]="carousel.uid">
          </aimo-cx-carousel>
        </div>
      </div>
    </div>
  } @else {
    <aimo-spinner></aimo-spinner>
  }
} @else {
  <aimo-spinner></aimo-spinner>
}

<ng-template #carouselItem let-item="item" let-index="index" let-idSuffix="idSuffix">
  <aimo-banner [banner]="item"></aimo-banner>
</ng-template>

